import React from "react";

import { ProjectLocationCustomNotes } from "./CustomNotes";
import { OnboardingStatus } from "./OnboardingStatus";
import { PickupFields } from "./PickupFields";
import { ProjectJoinDate } from "./ProjectJoinDate";
import useLocation from "../../../../containers/FacilityDetailsPage/hooks/useLocation";
import { OptionalRender } from "../../../Common/OptionalRender";
import ScoreItem from "../../../ScoreItem";
import { useProjectsLocations } from "../hooks";

import "./styles.scss";

export interface IProjectFacilityDetailsModalProps {
  organizationId: string;
  projectId: string;
  projectLocationId: string;
  handleClose: () => void;
}

export const ProjectFacilityDetailsModal: React.FC<
  IProjectFacilityDetailsModalProps
> = (props) => {
  const { organizationId, projectId, projectLocationId, handleClose } = props;

  const projectsLocationsQuery = useProjectsLocations(
    organizationId,
    projectId
  );

  const projectLocation = projectsLocationsQuery.query.data?.data.find(
    (item) => item.id.toString() === projectLocationId
  );

  const { data: locationData } = useLocation(projectLocation?.location.id);

  return (
    <div className="modal modal-default modal-project-facility-details">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <div>
            <div className="top-title">
              <span>{projectLocation?.location.name}</span>
              <ScoreItem
                score={projectLocation?.location.location_stats?.score || "n"}
              />
            </div>
            <ProjectJoinDate
              organizationId={organizationId}
              projectLocation={projectLocation}
            />
          </div>
          <div className="basic-info">
            {locationData && (
              <PickupFields locationData={locationData}></PickupFields>
            )}
          </div>
          <OptionalRender mustBeEnvironment={["local", "staging"]}>
            <div className="onboarding-status-section">
              <OnboardingStatus
                organizationId={organizationId}
                projectLocation={projectLocation}
              />
            </div>
          </OptionalRender>
          <div className="custom-notes">
            <ProjectLocationCustomNotes
              organizationId={organizationId}
              projectLocation={projectLocation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
